import { Card, Divider, Tag, Typography } from 'antd';
import { PhoneOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import UserAvatar from '../../components/UserAvatar';

function DetailBlock({ icon, label, value }) {
  const text = value?.trim() || "";
  return (
    <div className="care-profile-detail-row">
      <span className="care-profile-detail-icon" aria-hidden>
        {icon}
      </span>
      <div className="care-profile-detail-body">
        <div className="care-profile-detail-label">{label}</div>
        <div className="care-profile-detail-value">{text}</div>
      </div>
    </div>
  );
}

export default function Profile() {
  const user = useSelector((state) => state.auth.user);
  const roleLabel = user?.role ? String(user.role).replace(/_/g, ' ') : "";

  return (
    <div className="care-page care-page-profile">
      <div className="care-profile-page">
        <Card className="care-profile-card" bordered={false}>
          <div className="care-profile-hero">
            <UserAvatar user={user} size={100} className="care-profile-avatar-ring" />
            <div className="care-profile-hero-copy">
              <Typography.Title level={3} className="care-profile-name">
                {user?.name?.trim() || 'Staff member'}
              </Typography.Title>
              {user?.email ? (
                <Typography.Text type="secondary" className="care-profile-email-line">
                  {user.email}
                </Typography.Text>
              ) : null}
              <div className="care-profile-badges">
                <Tag className="care-profile-role-tag">{roleLabel}</Tag>
                <Tag
                  icon={<SafetyCertificateOutlined />}
                  className={`care-profile-verify-tag ${
                    user?.verified
                      ? 'care-profile-verify-tag--verified'
                      : 'care-profile-verify-tag--unverified'
                  }`}
                >
                  {user?.verified ? 'Verified' : 'Unverified'}
                </Tag>
              </div>
            </div>
          </div>

          <Divider className="care-profile-divider" />

          <div className="care-profile-details">
            <DetailBlock icon={<PhoneOutlined />} label="Phone" value={user?.phone} />
          </div>
        </Card>
      </div>
    </div>
  );
}
